import { isArray } from "underscore";
import ProductRepository from "../../repository/ProductRepository";
import Constants from "src/helper/Constants";

class quoteDetailAPICallResponseMaker {
    data = {};
    data_to_send = {};

    constructor(data) {
        this.data_to_send = this.defaultValue();
        this.data = data;
    }

    static statusList = {
        "Approved": { id: "A", text: "Approved", slug: 'Approved' },
        "Pending": { id: "P", text: "Pending", slug: 'Pending' },
        "No Bid": { id: "B", text: "No Bid", slug: 'NoBid' },
        "Booked": { id: "R", text: "Booked", slug: 'Booked' },
    };

    defaultValue = () => {
        return {
            cart_quote_active_session: {},
            quoteNumber: "",
            quoteRevisionNumber: "",
            quoteReferenceNumber: "",
            displayQuoteNumber: "",
            quoteReasonType: "",
            quoteStatus: null,
            accountNo: "",
            salesOrg: "",
            endCustomerName: "",
            line_items_axios_fetch_slug: false,
            line_items: {
                Approved: {
                    count: 0,
                    records: {},
                    api_query_param: quoteDetailAPICallResponseMaker.statusList["Approved"].id,
                    slug: 'Approved'
                },
                Pending: {
                    count: 0,
                    records: {},
                    api_query_param: quoteDetailAPICallResponseMaker.statusList["Pending"].id,
                    slug: 'Pending'
                },
                NoBid: {
                    count: 0,
                    records: {},
                    api_query_param: quoteDetailAPICallResponseMaker.statusList["No Bid"].id,
                    slug: 'NoBid'
                },
                Booked: {
                    count: 0,
                    records: {},
                    api_query_param: quoteDetailAPICallResponseMaker.statusList["Booked"].id,
                    slug: 'Booked'
                },
            }
        };
    };



    process = async (axios_params = {}) => {
        if (Object.keys(this.data)?.length > 0) {
            if (this.data.quoteNumber !== undefined) {
                this.data_to_send.quoteNumber = this.data.quoteNumber;
            }
            if (this.data.quoteRevisionNumber !== undefined) {
                this.data_to_send.quoteRevisionNumber = this.data.quoteRevisionNumber;
            }

            if (this.data.displayQuoteNumber !== undefined) {
                this.data_to_send.displayQuoteNumber = this.data.displayQuoteNumber;
            }
            if (this.data.endCustomerName !== undefined) {
                this.data_to_send.endCustomerName = this.data.endCustomerName;
            }
            if (this.data.contactName !== undefined) {
                this.data_to_send.contactName = this.data.contactName;
            }
            if (this.data.contactPhone !== undefined) {
                this.data_to_send.contactPhone = this.data.contactPhone;
            }

            if (this.data.totalApproved !== undefined) {
                this.data_to_send.line_items.Approved.count = this.data.totalApproved;
            } else if (this.data?.totalOtherQuotesCount?.totalApproved) {
                this.data_to_send.line_items.Approved.count = this.data?.totalOtherQuotesCount?.totalApproved;
            }

            if (this.data.totalPending !== undefined) {
                this.data_to_send.line_items.Pending.count = this.data.totalPending;
            } else if (this.data?.totalOtherQuotesCount?.totalPending) {
                this.data_to_send.line_items.Pending.count = this.data.totalOtherQuotesCount.totalPending;
            }

            if (this.data.totalNoBid !== undefined) {
                this.data_to_send.line_items.NoBid.count = this.data.totalNoBid;
            } else if (this.data?.totalOtherQuotesCount?.totalNoBid) {
                this.data_to_send.line_items.NoBid.count = this.data.totalOtherQuotesCount.totalNoBid;
            }

            if (this.data.totalBooked !== undefined) {
                this.data_to_send.line_items.Booked.count = this.data.totalBooked;
            } else if (this.data?.totalOtherQuotesCount?.totalBooked) {
                this.data_to_send.line_items.Booked.count = this.data.totalOtherQuotesCount.totalBooked;
            }

            if (axios_params.quoteStatus !== undefined &&
                this.data.quoteLineItemRecords !== undefined && isArray(this.data.quoteLineItemRecords) && this.data.quoteLineItemRecords.length > 0) {
                let slug;
                if (axios_params.quoteStatus &&
                    quoteDetailAPICallResponseMaker.statusList[axios_params.quoteStatus] !== undefined) {
                    slug = quoteDetailAPICallResponseMaker.statusList[axios_params.quoteStatus].slug;
                }
                if (slug) {
                    let quoteLineItems = {};
                    this.data.quoteLineItemRecords.map((v) => {
                        let quoteLineItemsHere = v;
                        let quotePriceDetails = {};
                        if (v.quotePriceDetails && isArray(v.quotePriceDetails) && v.quotePriceDetails.length > 0) {
                            v.quotePriceDetails.map((vMain, vInner) => {
                                Object.entries(vMain).map((vMainValue, vMainIndex) => {
                                    quotePriceDetails[vMainValue[0] + '_quantity_' + (vInner + 1)] = vMainValue[1];
                                })

                            });
                        }
                        delete quoteLineItemsHere.quotePriceDetails;
                        quoteLineItemsHere.ERPPartNumber = v.sapMaterialId;
                        quoteLineItemsHere.uniqueLineItem = quoteLineItemsHere.customerLineNumber; // quoteLineNumber getting "0000" from API (no any unique value for the quote detail)
                        quoteLineItemsHere.status = slug;
                        quoteLineItemsHere.quoteNumber = this.data.quoteNumber;
                        quoteLineItemsHere.ERPMFRPartNumber = quoteLineItemsHere.requestedMFPartNumber;
                        quoteLineItems[quoteLineItemsHere.quoteLineNumber] = { ...quoteLineItemsHere, ...quotePriceDetails };
                    });

                    const product = await new ProductRepository().getProductPriceInventoryAssets(quoteLineItems, { currency: Constants.currencyType.USD });

                    let erpMfrSearchItems = {};

                    Object.entries(quoteLineItems).map((vMain, vInner) => {
                        vMain[1].scheduleDetails = [];
                        vMain[1].subTotal_quantity_1 = (vMain[1].quantity_quantity_1 * vMain[1].price_quantity_1);
                        vMain[1].subTotal_quantity_2 = vMain[1].quantity_quantity_2 ? (vMain[1].quantity_quantity_2 * vMain[1].price_quantity_2) : 0;
                        vMain[1].subTotal_quantity_3 = vMain[1].quantity_quantity_3 ? (vMain[1].quantity_quantity_3 * vMain[1].price_quantity_3) : 0;

                        if (Object.entries(product).length > 0) {
                            let _prd = Object.entries(product).find(prd => prd[1].SapPartNumber === vMain[1].sapMaterialId)
                            if (_prd) {
                                // do nothing
                            } else {
                                erpMfrSearchItems[vMain[0]] = vMain[1];
                            }
                        } else {
                            erpMfrSearchItems[vMain[0]] = vMain[1];
                        }
                    });


                    if (Object.entries(erpMfrSearchItems).length > 0) {
                        const productList = await new ProductRepository().getProductPriceInventoryAssets(erpMfrSearchItems, { currency: Constants.currencyType.USD, erpMFRExists: true, isFrom: Constants.systemModules.Quote });

                        Object.entries(quoteLineItems).map((vMain, vInner) => {

                            if (Object.entries(productList).length > 0) {
                                let _prd = Object.entries(productList).find(prd => prd[1].SapPartNumber === vMain[1].sapMaterialId)
                                if (_prd) {
                                    //do nothing
                                } else {
                                    _prd = Object.entries(productList).find(prd => prd[1].ERPMFRPartNumber === vMain[1].ERPMFRPartNumber)
                                    if (_prd) {
                                        vMain[1].sapMaterialId = _prd[1].SapPartNumber;
                                        vMain[1].manufacturer = _prd[1].ManufacturerName;
                                        vMain[1].manufacturerPartNumber = _prd[1].ERPMFRPartNumber;
                                        vMain[1].ERPPartNumber = _prd[1].ERPPartNumber;
                                    }
                                }
                            }
                        });

                    }

                    this.data_to_send.line_items[slug].records = quoteLineItems;

                    if (this.data.totalRecords !== undefined) {
                        this.data_to_send.line_items[slug].count = this.data.totalRecords;
                    }
                    this.data_to_send.line_items_axios_fetch_slug = slug;
                }
            }
        } else {
            if (axios_params.quoteStatus &&
                quoteDetailAPICallResponseMaker.statusList[axios_params.quoteStatus] !== undefined) {
                let slug = quoteDetailAPICallResponseMaker.statusList[axios_params.quoteStatus].slug;
                this.data_to_send.line_items_axios_fetch_slug = slug;
            }
        }
        return this;
    };

    // validateQtyMinMult = (selectedQty, qtyMin, qtyMult) => {

    //     if (selectedQty && selectedQty > 0) {
    //         if (qtyMin !== undefined && selectedQty < qtyMin) {
    //             return false;
    //         }
    //         if (qtyMult !== undefined && selectedQty % qtyMult !== 0) {
    //             return false;
    //         }
    //     }
    //     return true;
    // };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default quoteDetailAPICallResponseMaker;